import React, { useState } from 'react';
import MygaSection from './PendingBusiness/PendingMygaSection';
import FiaSection from './PendingBusiness/PendingFiaSection';
import SpiaSection from './PendingBusiness/PendingSpiaSection';
import MedSupSection from './PendingBusiness/PendingMedSupSection';
import SPDASection from './PendingBusiness/PendingSPDASection';
import FilterIcon from "../../SVG/Filter";
import SearchableSelect from '../Shared/SearchableSelect';


// Example subnav component
const PendingBusinessNav = ({ types, selectedType, onSelectType }) => {
    return (
        <div className="agent-business-subnav">
            {types.map((type) => (
                <button
                    key={type}
                    onClick={() => onSelectType(type)}
                    className={`agent-business-selector ${selectedType === type ? 'active' : ''}`}
                >
                    {type}
                </button>
            ))}
        </div>
    );
};

// Main section component
const PendingBusinessSection = ({ model }) => {
    //ENV Variables
    const envTypes = import.meta.env.VITE_PENDING_TYPES || '';
    const types = envTypes
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

    // Fallback if unset
    const finalTypes = types.length ? types : ['SPDA', 'MYGA', 'SPIA', 'FIA', 'MS'];
    const [selectedType, setSelectedType] = useState(types[0]);
    const [agtCode, setAgtCode] = useState("all");
    const [polNo, setPolNo] = useState(undefined);
    const [ownerName, setOwnerName] = useState(undefined);
    const [status, setStatus] = useState(undefined);
    const downLines = model.downlines || [];

    return (
        <div className="container container-section" id="current-business-container">

            {/* Filter Box */}
            <div className="filter-box">
                <FilterIcon />
                <div className="filter-item">
                    <label htmlFor="agtCode" className="filterLabel">Downline</label>
                    <select
                        id="agtCode"
                        className="filterInput"
                        value={agtCode}
                        onChange={(e) => setAgtCode(e.target.value)}
                    >
                         All option 
                        <option value="All">All</option>

                        <option value={model.agtCode}>
                            {model.agtCode} - {model.agentInfo.displayName || "You"}
                        </option>
                        {downLines.map((dl) => (
                            <option key={dl.agentCode} value={dl.agentCode}>
                                {dl.agentCode} - {dl.displayName}
                            </option>
                        ))}
                    </select>
                    {/*<SearchableSelect*/}
                    {/*    options={agentOptions}*/}
                    {/*    value={agtCode}*/}
                    {/*    onChange={setAgtCode}*/}
                    {/*    placeholder="Type to search agents�"*/}
                    {/*    allowAll={true}*/}
                    {/*    allValue="All"*/}
                    {/*    allLabel="All"*/}
                    {/*    // keep your existing input styling*/}
                    {/*    className="filterInput"*/}
                    {/*    menuClassName="searchable-menu"*/}
                    {/*/>*/}
                </div>
                <div className="filter-item">
                    <label htmlFor="polNo" className="filterLabel">Policy</label>
                    <input
                        type="text"
                        className="filterInput"
                        value={polNo}
                        onChange={(e) => setPolNo(e.target.value)}
                    />
                </div>
                <div className="filter-item">
                    <label htmlFor="ownerName" className="filterLabel">Owner</label>
                    <input
                        type="text"
                        className="filterInput"
                        value={ownerName}
                        onChange={(e) => setOwnerName(e.target.value)}
                    />
                </div>
                <div className="filter-item">
                    <label htmlFor="status" className="filterLabel">Status</label>
                    <select
                        id="status"
                        className="filterInput"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        All option
                        <option value="All">All</option>
                        <option value="Not Taken">Not Taken</option>
                        <option value="Withdrawn">Withdrawn</option>
                        <option value="Pending Transfer Requirements">Pending Transfer Requirements</option>
                        <option value="Issued and Delivered">Issued and Delivered</option>
                        <option value="Duplicate">Duplicate</option>
                    </select>
                </div>
            </div>

            <div className="agent-business-container">
                <PendingBusinessNav
                    types={finalTypes}
                    selectedType={selectedType}
                    onSelectType={setSelectedType}
                />

                {selectedType === 'MYGA' && (
                    <MygaSection model={model} agtCode={agtCode} polNo={polNo} status={status} ownerName={ownerName} />
                )}

                {selectedType === 'FIA' && (
                    <FiaSection model={model} agtCode={agtCode} polNo={polNo} status={status} ownerName={ownerName} />
                )}

                {selectedType === 'SPIA' && (
                    <SpiaSection model={model} agtCode={agtCode} polNo={polNo} status={status} ownerName={ownerName} />
                )}

                {selectedType === 'Health' && (
                    <SpiaSection model={model} agtCode={agtCode} polNo={polNo} status={status} ownerName={ownerName} />
                )}

                {selectedType === 'MS' && (
                    <MedSupSection model={model} agtCode={agtCode} polNo={polNo} status={status} ownerName={ownerName} />
                )}

                {selectedType === 'Life' && (
                    <SpiaSection model={model} agtCode={agtCode} polNo={polNo} status={status} ownerName={ownerName} />
                )}

                {selectedType === 'SPDA' && (
                    <SPDASection model={model} agtCode={agtCode} polNo={polNo} status={status} ownerName={ownerName} />
                )}
            </div>
        </div>
    );
};


export default PendingBusinessSection;
